import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {SalesPhoneEnrollmentComponent} from "./sales-phone-enrollment.component";
import {
  SalesPhoneEnrollmentManualAppInstalationComponent
} from "./manual/app-instalation/sales-phone-enrollment-manual-app-instalation.component";
import {
  SalesPhoneEnrollmentManualFailMessageComponent
} from "./manual/fail-message/sales-phone-enrollment-manual-fail-message.component";
import {
  SalesPhoneEnrollmentManualInProgressComponent
} from "./manual/in-progress/sales-phone-enrollment-manual-in-progress.component";
import {
  SalesPhoneEnrollmentManualInitEnrollmentKnoxComponent
} from "./manual/init-enrollment/knox/sales-phone-enrollment-manual-init-enrollment-knox.component";
import {
  SalesPhoneEnrollmentManualInitEnrollmentNuovoComponent
} from "./manual/init-enrollment/nuovo/sales-phone-enrollment-manual-init-enrollment-nuovo.component";
import {
  SalesPhoneEnrollmentManualInitEnrollmentTrustonicComponent
} from "./manual/init-enrollment/trustonic/sales-phone-enrollment-manual-init-enrollment-trustonic.component";
import {
  SalesPhoneEnrollmentManualInitEnrollmentDatacultrComponent
} from "./manual/init-enrollment/datacultr/sales-phone-enrollment-manual-init-enrollment-datacultr.component";
import {
  SalesPhoneEnrollmentManualQuestionsProcessComponent
} from "./manual/questions-process/sales-phone-enrollment-manual-questions-process.component";
import {
  SalesPhoneEnrollmentManualQuestionsProcessNuovoComponent
} from "./manual/questions-process/nuovo/sales-phone-enrollment-manual-questions-process-nuovo.component";
import {
  SalesPhoneEnrollmentManualQuestionsProcessTrustonicComponent
} from "./manual/questions-process/trustonic/sales-phone-enrollment-manual-questions-process-trustonic.component";
import {
  SalesPhoneEnrollmentManualQuestionsProcessDatacultrComponent
} from "./manual/questions-process/datacultr/sales-phone-enrollment-manual-questions-process-datacultr.component";
import {
  SalesPhoneEnrollmentManualRetryMessageComponent
} from "./manual/retry-message/sales-phone-enrollment-manual-retry-message.component";
import {ReactiveFormsModule} from "@angular/forms";
import {LibraryModule} from "library";
import {PrimengModule} from "../../shared/primeng-module/primeng.module";
import {GeneralModule} from "../general/general.module";
import {QRCodeModule} from "angularx-qrcode";
import {
  SalesPhoneEnrollmentLibraryModule
} from "../phone-enrollment-library/sales-phone-enrollment-library.module";




@NgModule({
  declarations: [
    SalesPhoneEnrollmentComponent,
    SalesPhoneEnrollmentManualAppInstalationComponent,
    SalesPhoneEnrollmentManualFailMessageComponent,
    SalesPhoneEnrollmentManualInProgressComponent,
    SalesPhoneEnrollmentManualInitEnrollmentKnoxComponent,
    SalesPhoneEnrollmentManualInitEnrollmentNuovoComponent,
    SalesPhoneEnrollmentManualInitEnrollmentTrustonicComponent,
    SalesPhoneEnrollmentManualInitEnrollmentDatacultrComponent,
    SalesPhoneEnrollmentManualQuestionsProcessComponent,
    SalesPhoneEnrollmentManualQuestionsProcessNuovoComponent,
    SalesPhoneEnrollmentManualQuestionsProcessTrustonicComponent,
    SalesPhoneEnrollmentManualQuestionsProcessDatacultrComponent,
    SalesPhoneEnrollmentManualRetryMessageComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    LibraryModule,
    PrimengModule,
    GeneralModule,
    QRCodeModule,
    SalesPhoneEnrollmentLibraryModule
  ],
  exports: [
    SalesPhoneEnrollmentComponent


  ]
})
export class SalesPhoneEnrollmentModule { }
